import React from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import treeChanges from 'tree-changes';

import { Card, Tabs, Tooltip, Spin } from 'antd';

import RtnDelProcessActions from '../../Stores/RtnDelProcess/Actions';

import GdsIss01Table from '../GdsIss01/GdsIss01Table';
import GdsIss0101Table from '../GdsIss0101/GdsIss0101Table';

const { TabPane } = Tabs;

class RtnDelProcessScreen extends React.PureComponent {
  componentDidMount() {
    const { curSiteFlowId, fetchRtnDelProcess } = this.props;
    if (curSiteFlowId > 0) {
      fetchRtnDelProcess();
    }
  }

  componentDidUpdate(prevProps) {
    const { curSiteFlowId, fetchRtnDelProcess } = this.props;

    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      if (curSiteFlowId > 0) {
        fetchRtnDelProcess();
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { intl, match, process, appPath, processIsLoading } = this.props;

    return (
      <Card>
        <Spin spinning={processIsLoading}>
          <Tabs type="card" activeKey={match.params.proc_type}>
            {process.map(value => (
              <TabPane
                tab={
                  // eslint-disable-next-line react/jsx-wrap-multilines
                  <Tooltip
                    placement="bottom"
                    title={intl.formatMessage({ id: `${value.proc_type.toLowerCase()}_desc` })}
                  >
                    <Link
                      style={value.proc_type !== match.params.proc_type ? { color: 'black' } : {}}
                      to={`${appPath}/rtnDelProcess/index/${value.proc_type}`}
                    >
                      <FormattedMessage id={`${value.proc_type.toLowerCase()}_label`} />
                    </Link>
                  </Tooltip>
                }
                key={value.proc_type}
              />
            ))}
          </Tabs>
        </Spin>

        {match.params.proc_type === 'GDS_ISS_01' && <GdsIss01Table match={match} />}
        {match.params.proc_type === 'GDS_ISS_01_01' && <GdsIss0101Table match={match} />}
      </Card>
    );
  }
}

RtnDelProcessScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,
  appPath: PropTypes.string,
  process: PropTypes.arrayOf(PropTypes.object),
  processIsLoading: PropTypes.bool,

  curSiteFlowId: PropTypes.number,
  fetchRtnDelProcess: PropTypes.func
};

RtnDelProcessScreen.defaultProps = {
  intl: {},
  match: {},
  appPath: '',
  process: [],
  processIsLoading: false,

  curSiteFlowId: 0,
  fetchRtnDelProcess() {}
};

const mapStateToProps = state => ({
  appPath: state.app.appPath,
  process: state.rtnDelProcess.process,
  processIsLoading: state.rtnDelProcess.processIsLoading,

  curSiteFlowId: state.app.curSiteFlowId
});

const mapDispatchToProps = dispatch => ({
  fetchRtnDelProcess: () => dispatch(RtnDelProcessActions.rtnDelProcessFetchRtnDelProcess())
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(RtnDelProcessScreen));
